import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { UsersService } from '../services/users.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private usersService: UsersService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        request = request.clone({ setHeaders: { 'as-admin': 'true' } });

        if(this.usersService.token && !request.headers.has('x-access-token')) {
            request = request.clone({
                setHeaders: {
                    'x-access-token': this.usersService.token
                }
            });
        }

        return next.handle(request);
    }
}
